import React from 'react';
const bonuses = [{
  n: 1,
  icon: '🌙',
  coverIcon: '🌙',
  title: 'Guía de Rescate Nocturno',
  desc: 'Alivio en 15 min cuando el ardor no te deja dormir.',
  cover: '#4A0080',
  spine: '#360060'
}, {
  n: 2,
  icon: '🍳',
  coverIcon: '🍳',
  title: 'Recetario Sin Dulce',
  desc: '20 recetas ricas que matan al hongo con ingredientes de tu súper.',
  cover: '#D4006E',
  spine: '#A80056'
}, {
  n: 3,
  icon: '🧴',
  coverIcon: '🧴',
  title: 'Revisión de Productos de Baño',
  desc: 'Los productos que destruyen tu pH todos los días sin que lo sepas.',
  cover: '#1F7A5C',
  spine: '#155C44'
}];
export function BonusSection() {
  return <section className="w-full bg-[#F8F5FC] px-5 py-14 sm:py-16" data-id="element-22">
      <div className="max-w-lg mx-auto" data-id="element-23">
        {/* Header */}
        <div className="text-center mb-9" data-id="element-24">
          <h2 className="text-[32px] sm:text-[38px] font-bold text-brand-text leading-[1.05]" data-id="element-25">
            + 3 Regalos Estratégicos
          </h2>
          <p className="text-brand-muted text-[16px] sm:text-[18px] leading-snug mt-3" data-id="element-26">
            Incluidos sin costo extra · Valor real del pack
          </p>
          <div className="inline-flex items-center gap-2 bg-brand-magenta text-white font-bold text-[15px] sm:text-[17px] rounded-full px-6 py-3 mt-6 shadow-[0_4px_24px_rgba(212,0,110,0.25)]" data-id="element-27">
            🎁 GRATIS POR EL DÍA DE HOY
          </div>
        </div>

        {/* Bonus cards */}
        <div className="flex flex-col gap-6" data-id="element-28">
          {bonuses.map(b => <div key={b.n} className="bg-white rounded-[24px] p-6 shadow-[0_8px_40px_rgba(74,0,128,0.08)] flex flex-col items-center text-center" data-id="element-29">
              {/* Book cover mockup */}
              <div className="relative w-[180px] h-[240px] rounded-r-xl rounded-l-md shadow-[0_12px_32px_rgba(0,0,0,0.18)] overflow-hidden flex flex-col justify-between p-5" style={{
            backgroundColor: b.cover
          }} data-id="element-30">
                {/* spine */}
                <div className="absolute left-0 top-0 bottom-0 w-3" style={{
              backgroundColor: b.spine
            }} data-id="element-31" />
                <span className="text-[32px] leading-none relative z-10 self-start" data-id="element-32">
                  {b.coverIcon}
                </span>
                <div className="relative z-10 text-left" data-id="element-33">
                  <span className="block text-white text-[24px] font-bold leading-tight" data-id="element-34">
                    Bonus {b.n}
                  </span>
                  <div className="w-12 h-px bg-white/40 my-3" data-id="element-35" />
                  <span className="block text-white/80 text-[11px] font-semibold uppercase tracking-widest" data-id="element-36">
                    Método pH-ZERO™
                  </span>
                </div>
              </div>

              {/* GRATIS badge */}
              <span className="inline-flex items-center bg-green-100 text-green-700 text-[13px] font-bold uppercase tracking-wide rounded-full px-4 py-1.5 mt-6" data-id="element-37">
                GRATIS
              </span>

              {/* Title + desc */}
              <h3 className="text-[22px] sm:text-[24px] font-bold text-brand-text leading-tight mt-4" data-id="element-38">
                {b.icon} Bonus {b.n} — {b.title}
              </h3>
              <p className="text-brand-muted text-[16px] leading-relaxed mt-2 max-w-xs" data-id="element-39">
                {b.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}